const $$splitComponentImporter = () => import('/app/frontend/src/routes/_auth/route.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute, redirect } from '@tanstack/react-router';

/** Fallback backdrop until a screen declares its own via `staticData`. */

// Each state screen under this group self-guards to the exact `frontendUserState` it represents.
export const Route = createFileRoute('/_auth')({
  beforeLoad: async ({
    context,
    location
  }) => {
    if (!context.auth.isAuthenticated) {
      throw redirect({
        to: '/login',
        search: {
          redirect: location.href
        }
      });
    }
    await context.ensureProfile();
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});